import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderDocument } from '@classes/order-document';

export interface EmailOrderDialogData {
  email?: string;
  invoiceNumber?: string;
}

@Component({
  selector: 'app-email-order-dialog',
  template: `
    <h2 mat-dialog-title>EMAIL INVOICE</h2>
    <mat-dialog-content>
      <p class="email-dialog-message">
        Confirm the customer email before sending a copy of this completed order.
        The original invoice is not changed.
      </p>
      <p *ngIf="data?.invoiceNumber" class="email-dialog-invoice">
        Invoice: {{ data.invoiceNumber }}
      </p>
      <mat-form-field class="email-dialog-field">
        <mat-label>EMAIL</mat-label>
        <input matInput type="email" [(ngModel)]="email" autocomplete="off" />
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()">CANCEL</button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="!canConfirm"
        (click)="confirm()"
      >
        EMAIL
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .email-dialog-message {
        margin: 0 0 12px;
        font-size: 13px;
        line-height: 1.4;
      }
      .email-dialog-invoice {
        margin: 0 0 12px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
      }
      .email-dialog-field {
        width: 100%;
      }
    `,
  ],
})
export class EmailOrderDialogComponent {
  email = '';

  constructor(
    public dialogRef: MatDialogRef<EmailOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EmailOrderDialogData
  ) {
    this.email = String(data?.email || '').trim();
  }

  get canConfirm(): boolean {
    return OrderDocument.isValidEmail(this.email);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    if (!this.canConfirm) {
      return;
    }
    this.dialogRef.close(String(this.email || '').trim());
  }
}
